function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDoubleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.3 7.41L6.71 6l6 6-6 6-1.41-1.41L9.88 12 5.3 7.41z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 7.41L12.71 6l6 6-6 6-1.41-1.41L15.88 12 11.3 7.41z",
    fill: props.fill
  }));
}
export default SvgChevronDoubleRight;